import React from 'react';
import {
    Card,
    CardContent,
    Stack,
    Typography,
    Chip,
    IconButton,
    Tooltip,
    Box,
} from '@mui/material';
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
    Home as HomeIcon,
    Work as WorkIcon,
    Star as StarIcon,
    Place as PlaceIcon,
} from '@mui/icons-material';
//import { getLocationTypeLabel } from '../../../utils/locationUtils';
import { getLocationTypeLabel } from '../../utils/persons/locationUtils';

const getTypeIcon = (type) => {
    switch (type) {
        case 'TRABAJO':
            return <WorkIcon fontSize="small" />;
        case 'CASA_PRINCIPAL':
        case 'CASA_SECUNDARIA':
            return <HomeIcon fontSize="small" />;
        default:
            return <PlaceIcon fontSize="small" />;
    }
};

export const PersonLocationCard = ({ location, onEdit, onDelete, disabled }) => {
    const isPrimary = location.perlocpri === true;

    return (
        <Card
            variant="outlined"
            sx={{
                borderRadius: 2,
                borderColor: isPrimary ? 'success.main' : 'divider',
                transition: 'all 0.2s',
                '&:hover': {
                    boxShadow: 1,
                },
            }}
        >
            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                <Stack spacing={1}>
                    <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                        <Box sx={{ minWidth: 0, flex: 1 }}>
                            <Typography fontWeight={700} variant="body2" noWrap>
                                {location.locnom}
                            </Typography>
                            {location.locdes && (
                                <Typography variant="caption" color="text.secondary" display="block" noWrap>
                                    {location.locdes}
                                </Typography>
                            )}
                        </Box>

                        <Stack direction="row" spacing={0.5}>
                            <Tooltip title="Editar">
                                <IconButton size="small" onClick={() => onEdit(location)} disabled={disabled}>
                                    <EditIcon fontSize="small" color="primary" />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Eliminar">
                                <IconButton size="small" onClick={() => onDelete(location)} disabled={disabled}>
                                    <DeleteIcon fontSize="small" color="error" />
                                </IconButton>
                            </Tooltip>
                        </Stack>
                    </Stack>

                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        <Chip
                            size="small"
                            icon={getTypeIcon(location.perloctip)}
                            label={getLocationTypeLabel(location.perloctip)}
                            variant="outlined"
                        />
                        {isPrimary && (
                            <Chip
                                size="small"
                                icon={<StarIcon sx={{ fontSize: 14 }} />}
                                label="Principal"
                                color="success"
                                variant="outlined"
                            />
                        )}
                    </Stack>

                    {location.perlocdes && (
                        <Typography variant="caption" color="text.secondary">
                            📝 {location.perlocdes}
                        </Typography>
                    )}

                    {(location.loclat || location.loclng) && (
                        <Typography variant="caption" color="text.secondary">
                            📍 {Number(location.loclat).toFixed(6)}, {Number(location.loclng).toFixed(6)}
                        </Typography>
                    )}
                </Stack>
            </CardContent>
        </Card>
    );
};